import { render, staticRenderFns } from "./PraticaDocumentActions.vue?vue&type=template&id=1f624bb6&"
import script from "./PraticaDocumentActions.vue?vue&type=script&lang=js&"
export * from "./PraticaDocumentActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f624bb6')) {
      api.createRecord('1f624bb6', component.options)
    } else {
      api.reload('1f624bb6', component.options)
    }
    module.hot.accept("./PraticaDocumentActions.vue?vue&type=template&id=1f624bb6&", function () {
      api.rerender('1f624bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaDocumentActions.vue"
export default component.exports